import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  schools: [],
  categories: [],
  schoolStages: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const setSchools = (state, payload) => (
  object.setIn(state, [ 'schools' ], payload)
)

export const setSchoolStages = (state, payload) => (
  object.setIn(state, [ 'schoolStages' ], payload)
)
